//
// RuntimeConfiguration.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "../moduleBuilder";
import EventDispatcher from "../events/EventDispatcher";
import "../lib";
import "../models/BaseModel";
import "./RuntimeScheme";
import "./PlatformImplementationFactory";

var RuntimeConfiguration = createModule("commons::RuntimeConfiguration", ["commons::PropertyOwner","commons::BaseModel"], EventDispatcher, [
    ,
    {
        implementationFactory: 1,
        scheme: 4,
        enableTraceLogging: 2,
        locale: 7,
        pathToFontDirectory: 7,
        stripNumericFormattedValues: 2,
        logLevel: 7,
        enableSystemFontLookups: 2,
        hasRunLoop: 2,
        formatterLocale: 7,
        pathToWorkingDirectory: 7,
        dpi: 5,
        pathToResourceDirectory: 7,
        logConfig: 7,
        pathToFontManifestFile: 7,
        enableTextureCaching: 2,
        defaultImageDataPolicies: 3,
        pathToInstallDirectory: 7,
        supportsMSAA: 2,
        requiresCoInitialize: 2,
        logFilePath: 7,
        supportsThreads: 2,
        supportsAsyncNetworking: 2,
        needsProxy: 2,
        missingOption: 7,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default RuntimeConfiguration;
